export default __webpack_public_path__ + "static/media/ArrowYellow.a8547912.svg";